import React from 'react'
import { sendSign } from '../../api/branchesRequests';
import Home from './Home'

export default function AddSignature() {

    function canGoNext(croppedImages){
        return croppedImages?.[0] && croppedImages?.[1];
    }

    return (
        <div>
            <Home canGoNext={canGoNext} validation={{required: true}} submitFunction={sendSign}/>
        </div>
    )
}
